import $ from 'jquery';
import 'slick-carousel';

function initSlider($slider, initial = 4, type, $currentSlide, $group) {

  $slider.on('init beforeChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $group.find(`.controls-dots-featured-slider-${type}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
    $slider.removeClass('opacity-0')
  });

  $slider.slick({
    slidesToShow: initial,
    slidesToScroll: initial,
    autoplay: false,
    dots: true,
    arrows: true,
    infinite: true,
    appendDots: $(`.controls-dots-featured-slider-${type}`),
    nextArrow: $(`.controls-next-featured-slider-${type}`),
    prevArrow: $(`.controls-prev-featured-slider-${type}`),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  // sets position
  $slider.on('init beforeChange afterChange', function (event, slick) {
    $slider.slick('setPosition');
  });

  // Adjusts height of all slides to the tallest one
  $slider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    if ($currentSlide) {
      $currentSlide.text(current + '/' + slick.slideCount);
    }
  });
}

if ($('.dsp-featured-na').length) {

  $('.dsp-featured-na').each(function () {
    let $group = $(this);
    const $currentSlide = $group.find('.slider-current-item');
    const type = $group.data('type');
    const hasSlider = $group.data('has-slider');
    const $featuredSlider = $group.find('.featured-slider');
    const initial = $featuredSlider.data('initial');

    if ($currentSlide) {
      $currentSlide.text('1/' + ($featuredSlider.find('.vehicle').length));
    }

    if (hasSlider == true) {
      initSlider($featuredSlider, initial, type, $currentSlide, $group);
    }
    
  });

}